/* Figma's "Main Column" (36:68): fills the screen, spreads its sections with
 * an automatic gap, centres them across. The gap is what absorbs a shorter
 * screen — the sections themselves keep the height Figma gives them. */
.column {
  position: absolute;
  inset: 0;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  padding: calc(var(--pad-top) * var(--u)) calc(var(--pad-inline) * var(--u))
    calc(var(--pad-bottom) * var(--u));
}
